import { AnimatePresence, motion } from 'motion/react';
import { useMemo } from 'react';
import { useMediaLoader } from '../../hooks/useMediaLoader';

import styles from './Prize.module.css';

import left from '../../assets/images/left.webp';
import right from '../../assets/images/right.webp';

export const Prize = ({ voteState }) => {
  const prize = useMemo(() => {
    const isCorrect = voteState?.vars.find((v) => v.correct)?.varImgUrl;

    return isCorrect;
  }, [voteState]);

  const urlImage = prize || right;

  const { isFullyLoaded } = useMediaLoader(urlImage, 'image');

  return (
    <div className={styles.presentWrapper}>
      <AnimatePresence mode="wait">
        {isFullyLoaded && (
          <motion.div
            className={styles.present}
            key={prize}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1, ease: 'easeInOut' }}
          >
            {prize ? (
              <img src={prize} alt="" className={styles.prize} />
            ) : (
              <>
                <img src={left} alt="" className={styles.left} />
                <img src={right} alt="" className={styles.right} />
              </>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
